<template>
    <answers ref="answers"
             code_question_group="GQ03"
             danger_code="MCAL24"
    />
</template>

<script>
import answers from '../../../components/answers.vue';

export default {
    name: 'index',
    components: {
        answers
    }
};
</script>
